import { useState, type FormEvent } from "react";
import { useNavigate, Link } from "react-router-dom";
import { hotKeywords } from "@/mocks/videos";

export default function HomeSearchBand() {
  const navigate = useNavigate();
  const [keyword, setKeyword] = useState("");

  const submit = (e: FormEvent) => {
    e.preventDefault();
    const q = keyword.trim();
    if (!q) return;
    navigate(`/search?q=${encodeURIComponent(q)}`);
  };

  return (
    <section className="w-full px-4 md:px-8">
      <div className="flex flex-col items-center gap-5 rounded-lg border border-primary-200 bg-primary-50 px-5 py-8 md:px-10 md:py-10">
        <div className="text-center">
          <h2 className="font-heading text-xl font-bold tracking-tight text-foreground-950 md:text-2xl">
            全网热点，一搜即达
          </h2>
          <p className="mt-2 text-sm text-foreground-600">
            输入关键词，快速找到明星动态、社会热点与趣味短片
          </p>
        </div>

        <form onSubmit={submit} className="flex w-full max-w-2xl flex-col gap-3 sm:flex-row">
          <div className="relative flex-1">
            <span className="pointer-events-none absolute left-4 top-1/2 flex h-4 w-4 -translate-y-1/2 items-center justify-center text-foreground-400">
              <i className="ri-search-line text-base" />
            </span>
            <input
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              type="text"
              name="q"
              placeholder="搜索：顶流歌手、暴雨互助、猫咪日常…"
              className="w-full rounded-full border border-background-200 bg-background-50 py-3 pl-11 pr-4 text-sm text-foreground-900 outline-none transition-colors placeholder:text-foreground-400 focus:border-primary-400"
            />
          </div>
          <button
            type="submit"
            className="flex items-center justify-center gap-2 rounded-full bg-primary-500 px-7 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 whitespace-nowrap"
          >
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-search-line text-base" />
            </span>
            搜索视频
          </button>
        </form>

        <div className="flex flex-wrap items-center justify-center gap-2">
          <span className="text-xs text-foreground-500">大家都在搜：</span>
          {hotKeywords.slice(0, 6).map((kw) => (
            <Link
              key={kw}
              to={`/search?q=${encodeURIComponent(kw)}`}
              className="rounded-full border border-background-200 bg-background-50 px-3 py-1 text-xs text-foreground-700 transition-colors hover:border-accent-300 hover:text-accent-600"
            >
              {kw}
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}